<template>
    <div class="head">
        <div class="system-brand">
            <div class="brand-logo">
                <div class="text-logo">小蔓</div>
            </div>
            <div class="brand-text">
                <div class="brand-name">
                  <span style="color: #ea4336;">MD-</span>
                  <span style="color: #4285f4;">ECDATA</span>
                </div>
                <div class="brand-desc">电商数据管理系统</div>
            </div>
        </div>
        <div class="system-user"> 
            <div class="system-user-home"><el-icon style="cursor: pointer;" @click.stop="homeClick"><HomeFilled/></el-icon></div>
            <el-dropdown size="large" @command="handMenu">
                <span class="el-dropdown-link" style="cursor: pointer;">
                    {{nickName}}（{{userName}}）【{{roleName}}】
                    <el-icon class="el-icon--right"><CaretBottom/></el-icon>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item command="changePwd" class="el-dropdown-item" style="font-family: 'PingFang SC';font-style: normal;font-weight: 600;font-size: 12px;color: #606266;"><el-icon><Edit/></el-icon>修改密码</el-dropdown-item>
                        <el-dropdown-item command="logout" class="el-dropdown-item" :divided=true style="font-family: 'PingFang SC';font-style: normal;font-weight: 600;font-size: 12px;color: #606266;"><el-icon><SwitchButton/></el-icon>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown> 
        </div>
    </div>
    <!-- ----------------------------------------------修改密码---------------------------------------------- -->
    <el-dialog v-model="dialogVisible" width="25%" :show-close="false" :before-close="handleClose" top="30vh"> 
        <template #header="{titleId}">
            <div class="my-header">
                <span :id="titleId" class="titleClass">修改密码</span> 
            </div>
        </template>
        <el-form ref="formData" :model="formData" label-width="10px" :rules="rules" class="dialog-form">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="" prop="oldPwd">
                        <el-input type="password" show-password v-model="formData.oldPwd" size="large" placeholder="请输入原密码"  :prefix-icon="Lock"> </el-input>  
                    </el-form-item>  
                </el-col>  
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="" prop="newPwd">
                        <el-input type="password" show-password v-model="formData.newPwd" size="large" placeholder="请输入新密码"  :prefix-icon="Lock"> </el-input>  
                    </el-form-item>  
                </el-col>  
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="" prop="newPwd1">
                        <el-input type="password" show-password v-model="formData.newPwd1" size="large" placeholder="确认新密码"  :prefix-icon="Lock"> </el-input>  
                    </el-form-item>  
                </el-col>  
            </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false;formData = {};">取消</el-button>
                <el-button type="primary" @click="changePwd('formData')">确定</el-button>
            </span>
        </template>
    </el-dialog>

</template>
<script>
import {SwitchButton,Edit,CaretBottom,HomeFilled,QuestionFilled,Avatar,Lock,View,Hide } from '@element-plus/icons-vue'
import { asyncPostLoading,asyncPost } from '../api/request'; 
import UserStorage from '../api/UserStorage';
export default { 
    setup(){  
        return {
            //在input框中，使用prefix，就必须在setup中return，否则无法显示图标
            SwitchButton,Edit,CaretBottom,HomeFilled,QuestionFilled,Avatar,Lock,View,Hide
        } 
    },
    components:{
        SwitchButton,Edit,CaretBottom,HomeFilled,QuestionFilled,Avatar,Lock,View,Hide
    },
    data:function(){ 
        return {
            dialogVisible: false,       //弹窗是否可用
            formData:{},                //新增编辑数据
            rules:{
                oldPwd:[
                    { required: true, min: 6, max: 18,message: '必须输入原密码，长度在6到18位之间！', trigger: 'blur' },
                ],
                newPwd:[
                    { required: true, min: 6, max: 18,message: '必须输入新密码，长度在6到18位之间！', trigger: 'blur' },
                    { pattern:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!@#$%^&*=\-`~?&])[A-Za-z\d$@$!@#$%^&*=\-`~?&]{6,18}$/,message:"密码必须包含字母、数字、特殊字符，且在6到18位之间"}
                ],
                newPwd1:[
                    { required: true, min: 6, max: 18,message: '必须输入新密码，长度在6到18位之间！', trigger: 'blur' },
                    { pattern:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!@#$%^&*=\-`~?&])[A-Za-z\d$@$!@#$%^&*=\-`~?&]{6,18}$/,message:"密码必须包含字母、数字、特殊字符，且在6到18位之间"}
                ] 
            }
        }
    },
    computed:{
        nickName(){ 
            return UserStorage.getUserInfo('nickName');
        },
        userName(){ 
            return UserStorage.getUserInfo('userName');
        },
        roleName(){ 
            return UserStorage.getUserInfo('roleName');
        }
    },
    methods:{
        //默认显示的控制台页
        homeClick(){
            this.$router.push({
                    path: '/console'
                });
        },
        //弹窗其他区域点击不关闭
        handleClose(done){ },
        handMenu(command){
            if(command == "logout") { 
                this.$ElMessageBox.confirm('确认要退出吗?','提示',{confirmButtonText: '确认',cancelButtonText: '取消',type: 'info', buttonSize: 'large'})
                .then(() => { 
                     this.logout();  //退出登录
                 }).catch(() => {});
            }else {
                //修改密码
                this.dialogVisible = true;
                this.formData = {};
            } 
        },
        logout(){
            asyncPost(this.$userURL + "/user/logout",{},res => {
                
                this.$router.push('/');
            },err => {
                this.$ElMessage.error(err);
            });  
            UserStorage.clear();
            this.$router.push('/login'); 
        },
        changePwd(formData){
            this.$refs[formData].validate(valid => {
                if(!valid) return; 
                //修改
                let url = this.$userURL + "/user/changePassword";
                if(this.formData['newPwd'] != this.formData['newPwd1']){
                    this.$ElMessage.error("两次密码输入不相同，请重新输入");
                    return;
                }
              
                asyncPostLoading(url,this.formData,res => {
                    if(res.data.head.st != 0){
                        this.$message.error(res.data.head.msg);
                        return;
                    } 
                    this.$ElMessage.success("修改密码成功");
                    this.logout();
                    this.dialogVisible = false;
                },err => {
                    this.$ElMessage.error(err);
                });  
            });
        }
    }
}
</script>

<style scoped>
.head {
  width: 100%;
  height: 70px;
  background: #FFFFFF;
  border-bottom: 1px solid #EBEEF5;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 999;
  color: #303133;
  background: linear-gradient(45deg, rgba(0, 0, 200, 0.05), #fff);
}

/* Logo 区域样式 */
.logo {
  height: 40px;
  width: 180px;
  display: flex;
  align-items: center;
}

.logo img {
  height: 32px;
  transition: all 0.3s;
}

/* 系统名称样式 */
.system-name {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-left: 8px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* 导航中间部分 */
.head-middle {
  flex: 1;
  display: flex;
  justify-content: center;
}

/* 面包屑导航 */
.breadcrumb {
  display: flex;
  align-items: center;
  color: #909399;
  font-size: 14px;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #C0C4CC;
}

.breadcrumb-item {
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
}

.breadcrumb-item:hover {
  color: #4170FF;
}

.breadcrumb-item.active {
  color: #303133;
  font-weight: 500;
}

/* 右侧功能区域 */
.head-right {
  display: flex;
  align-items: center;
}

/* 功能按钮公共样式 */
.function-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #606266;
  margin-left: 12px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.function-button:hover {
  background-color: rgba(65, 112, 255, 0.1);
  color: #4170FF;
}

/* 图标样式统一 */
.function-button .el-icon,
.function-button svg {
  font-size: 20px;
}

/* 用户区域 */
.user-info {
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 32px;
  border-radius: 16px;
  margin-left: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.user-info:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #E6F0FF;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4170FF;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid #E6F0FF;
  overflow: hidden;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-name {
  margin-left: 8px;
  font-size: 14px;
  color: #303133;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 下拉菜单样式 */
:deep(.el-dropdown-menu) {
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #EBEEF5;
  padding: 6px 0;
}

:deep(.el-dropdown-menu__item) {
  padding: 8px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 0.3s;
  color: #303133;
}

:deep(.el-dropdown-menu__item:hover) {
  background-color: rgba(65, 112, 255, 0.05);
  color: #4170FF;
}

:deep(.el-dropdown-menu__item i) {
  margin-right: 8px;
  font-size: 16px;
}

/* 通知徽标 */
.notification-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: #F56C6C;
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-sizing: border-box;
}

/* 全屏按钮样式 */
.fullscreen-button {
  margin-left: 12px;
}

/* 主题切换按钮 */
.theme-switch {
  margin-left: 12px;
  display: flex;
  align-items: center;
}

/* 搜索框 */
.search-input {
  margin-right: 16px;
  max-width: 200px;
  transition: all 0.3s;
}

:deep(.search-input .el-input__inner) {
  border-radius: 20px;
  background-color: #F5F7FA;
  border: none;
  padding-left: 12px;
  transition: all 0.3s;
}

:deep(.search-input .el-input__inner:focus) {
  background-color: white;
  border: 1px solid #4170FF;
  box-shadow: 0 0 0 2px rgba(65, 112, 255, 0.1);
}

:deep(.search-input .el-input__suffix) {
  right: 8px;
}

/* 密码修改对话框样式 */
.password-dialog :deep(.el-input__inner) {
  border-radius: 4px;
}

.password-dialog :deep(.el-button) {
  border-radius: 4px;
  transition: all 0.3s;
}

.password-dialog :deep(.el-button--primary) {
  background-color: #4170FF;
}

.password-dialog :deep(.el-button--primary:hover) {
  background-color: #5680FF;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(65, 112, 255, 0.3);
}

/* 折叠按钮 */
.collapse-btn {
  font-size: 20px;
  margin-right: 20px;
  cursor: pointer;
  color: #606266;
  transition: all 0.3s;
}

.collapse-btn:hover {
  color: #4170FF;
  transform: scale(1.1);
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .head-middle {
    display: none;
  }
  
  .user-name {
    display: none;
  }
  
  .function-button {
    margin-left: 8px;
  }
}

/* 系统品牌区域 */
.system-brand {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 20px;
  margin-left: -10px;
  border-radius: 0 20px 20px 0;
  min-width: 300px;
}

.brand-logo {
  height: 63px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.brand-logo img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.brand-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.brand-name {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.3;
  color: #333;
}

.brand-desc {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.5px;
}

/* 用户区域文字颜色调整 */
.system-user {
  color: #303133;
}

.system-user .el-icon {
  color: #606266;
}

/* 下拉箭头颜色 */
.el-dropdown-link .el-icon {
  color: #606266;
}

/* 文字 logo 样式 - 增大并强化效果 */
.text-logo {
  font-size: 36px;
  font-weight: 800;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #4170FF, #8E2DE2, #FF5D9E);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 2px 8px rgba(65, 112, 255, 0.3);
  animation: gradientShift 8s ease infinite;
  padding: 0 5px;
}

/* 渐变色彩动画 */
@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.dialog-footer .el-button{
  height: 36px;
}
</style>